export { default as AnalisisDRC } from "./modos/AnalisisDRC";
export { default as ValidacionDRC } from "./modos/ValidacionDRC";
export { default as DetalleDRC } from "./modos/DetalleDRC";

